import React, { useState, useEffect } from "react";
import axios from "axios";
import Cookies from "js-cookie";
import UserNavbar from "./UserNavbar";
import { useNavigate } from "react-router-dom";
import IntroductionContent from "./DocumentationContent/Introduction";
import GettingStarted from "./DocumentationContent/GettingStarted";
import DashboardContent from "./DocumentationContent/Dashboard";
import ConfigurationContent from "./DocumentationContent/ConfigurationContent";
import MonitoringContent from "./DocumentationContent/MonitoringContent";
import ReportsContent from "./DocumentationContent/ReportsContent";
import ConsoleContent from "./DocumentationContent/ConsoleContent";
import { useDashboard } from "../contexts/DashboardContext";

const Documentation = () => {
  const navigate = useNavigate();
  const token = Cookies.get("token");
  const [activeSection, setActiveSection] = useState("introduction");
  const { setActiveNav } = useDashboard();

  useEffect(() => {
    if (!token) {
      navigate("/signin");
    } else {
      axios
        .get("/api/token/isLoggedIn", {
          headers: {
            "x-auth-token": token,
          },
        })
        .then((res) => console.log(res.data))
        .catch(() => navigate("/signin"));
    }
  }, []);

  useEffect(() => {
    setActiveNav("documentation");
  }, []);

  const sections = {
    introduction: <IntroductionContent />,
    setup: <GettingStarted />,
    dashboard: <DashboardContent />,
    configuration: <ConfigurationContent />,
    monitoring: <MonitoringContent />,
    reports: <ReportsContent />,
    console: <ConsoleContent />,
  };

  return (
    <>
      <UserNavbar />
      <div className="flex min-h-screen bg-gray-100 lg:mx-64">
        <div className="flex-grow bg-white p-8">
          <div className="text-lg text-gray-700">{sections[activeSection]}</div>
        </div>

        <div className="w-64 bg-white text-black p-6 space-y-4 fixed right-0 h-full">
          <ul className="space-y-2">
            {Object.keys(sections).map((section) => (
              <li
                key={section}
                onClick={() => setActiveSection(section)}
                className={`cursor-pointer hover:bg-[#b2ebff] p-2 rounded ${
                  activeSection === section ? "bg-[#b2ebff]" : ""
                }`}
              >
                {section.charAt(0).toUpperCase() + section.slice(1)}
              </li>
            ))}
          </ul>
        </div>
      </div>
    </>
  );
};

export default Documentation;
